import React from "react";
// import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import {
  DragOverlay,
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

export const getCommentWrapperId = (commentUuid) => `comment_wrapper_${commentUuid}`;

export const SortableNarrativeCommentItem = React.memo(({ comment, index, render }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      setActivatorNodeRef,
    } = useSortable({ id: comment.uuid, handle: true });

    const style = {
      transform: CSS.Transform?.toString(transform),
      transition,
      zIndex: 1,
    };

    return (
      <div ref={setNodeRef} id={getCommentWrapperId(comment.uuid)} style={style} {...attributes}>
        {render(comment, index, setActivatorNodeRef, listeners)}
      </div>
    );
  });